import { twMerge } from 'tailwind-merge';
import { ProductType } from 'types/product';
import { CardType } from '../types';
import ProductTagItem from './product-tag-item';

type Props = {
  data?: ProductType;
  classNames?: string;
  activityTagLimit?: number | null;
  tagClassName?: string;
  tagItemClassName?: string;
  tagItemNameCls?: string;
} & CardType;
export default function ProductTags(props: Props) {
  const { activityTagLimit = null, tagClassName = '', tagItemClassName = '', tagItemNameCls = '' } = props;
  let { product_tag_list = [] } = props?.data || {};

  if (product_tag_list?.length === 0) return null;

  if (!!activityTagLimit && Number.isInteger(activityTagLimit) && activityTagLimit > 0) {
    product_tag_list = product_tag_list.slice(0, activityTagLimit);
  }

  return (
    <div
      data-testid="wid-product-card-tags"
      className={twMerge('flex max-w-full gap-y-1', props.classNames, tagClassName)}
      style={{ flexFlow: 'wrap' }}>
      {product_tag_list?.map((tag, index) => {
        return (
          <ProductTagItem
            key={`${tag?.tag_key}-${index}`}
            tag={tag}
            index={index}
            tagItemClassName={tagItemClassName}
            className={tagItemNameCls}
          />
        );
      })}
    </div>
  );
}
